import Yup from '_zari/validation/_yup'

const validationSchema = Yup.object().shape({
  fechaEmision: Yup.string().required(),
  tipoCambio: Yup.number().min(1).required(),
  glosa: Yup.string().required(),
  importe: Yup.number().required(),
  moneda: Yup.string().required(),
  cuentaContable: Yup.string().required(),
  _idCentroCostoNivel1: Yup.string().when('flagCentroCosto', {
    is: true,
    then: Yup.string().required()
  }),
  _idCentroCostoNivel2: Yup.string().when('flagCentroCosto', {
    is: true,
    then: Yup.string().required()
  })
})

export default validationSchema
